var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"conductor-job-status",class:_vm.derived},[_vm._v("\n\t"+_vm._s(_vm.derived)),(_vm.derived == 'waiting')?[_vm._v(" "+_vm._s(_vm.relative))]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }